import React from "react";
import {Navigate} from "react-router-dom";
import uisFetch from '../../utils/uisFetch';
import { fetchAndConvertToBase64 } from '../../utils/FileUtils';

class CustomerReturn extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            OTP: "",
            OTPInputAlert: "",
            detail: {
                Id: 0,
                StaffERN: "",
                LastName: "",
                FirstName: "",
                PreferredName: "",
                Position: "",
                DetailList: []
            },
            SubmitAlert: "",
            CanvasUpdated: false,
            IsMobileView: Boolean,
            IsTabletView: Boolean,
            IsSmMobileView: Boolean,
            modelTitle: '',
            modelImgIds: {},
            modelUniformID: '',
            measurementImages: {},
            uniformdownloadattachement: {},
            loadingImages: {}, // Loading state for images
            imageLoadTimestamps: {} // Image load timestamps
        }
        
        // Anti-duplicate request cooldown period (milliseconds)
        this.REQUEST_COOLDOWN = 5000; // 5 seconds
    }

    componentWillUnmount() {
        this.setState({
            measurementImages: {},
            uniformdownloadattachement: {},
            loadingImages: {},
            imageLoadTimestamps: {}
        });
    }


    componentDidMount() {
        // Check permission first
        if (this.props.hasPermission === false) {
            // No permission, redirect to home page
            window.location.href = process.env.PUBLIC_URL || "/";
            return;
        }

        this.setState({OTP: ""});
        $('#inpOTP').focus();

        let search = window.location.search;
        let params = new URLSearchParams(search);
        let defaultOTP = params.get('OTP');
        if (defaultOTP != null) {
            this.setState({OTP: defaultOTP}, () => {
                this.forceUpdate();
                this.Proceed();
            });

        }

        this.setState({IsMobileView: window.innerWidth <= 1024});
        this.setState({IsTabletView: window.innerWidth >= 768});
        this.setState({IsSmMobileView: window.innerWidth <= 370});
        window.addEventListener('resize', () => {
            this.setState({
                IsMobileView: window.innerWidth <= 1024
            });
            this.setState({
                IsTabletView: window.innerWidth >= 768
            });
            this.setState({
                IsSmMobileView: window.innerWidth <= 370
            }, () => {
                console.log(this.state.IsSmMobileView + " " + window.innerWidth)
            });
        }, false);

        const script = document.createElement('script');
        script.src = `${process.env.PUBLIC_URL}/scripts/signature.js`;
        script.async = true;
        // script.onload = () => {
        //     console.log('Script loaded successfully');
        // };
        document.body.appendChild(script);

        // Save script reference for cleanup
        this.signatureScript = script;
    }

    componentWillUnmount() {
        // Clean up script
        if (this.signatureScript && this.signatureScript.parentNode) {
            this.signatureScript.parentNode.removeChild(this.signatureScript);
        }
    }


    UpdateOTP(e) {
        console.log(e.target.value);
        this.setState({OTP: e.target.value});
    }


    Go(e) {
        if (e.key === 'Enter') {
            //$('#btnContinue').click();
            e.preventDefault();
            this.Proceed();
        }
    }


    Proceed = () => {
        this.setState({OTPInputAlert: ""});

        if (this.state.OTP == null || this.state.OTP == "") {
            this.setState({OTPInputAlert: "Please input valid PIN"});
            return;
        }


        const url = this.props.apiprefix + 'pbreturngetdetails?otp=' + this.state.OTP;
        uisFetch(this.props.accessToken,url, {
            //mode: 'no-cors',
            method: "GET",
            headers: {
                
            }
        }).then((response) => {
            return response.json()
        }).then((result) => {
            if (this.props.debug) console.log("[Public] pbreturngetdetails - result = " + result);
            if (result == null) {
                this.setState({OTPInputAlert: "No Return Form returned. Please Try Again"});
                return;
            }
            this.setState({detail: result});
            console.log(this.state.detail);
            $('#btnProceed').click();
            $('#sig-canvas').focus();


        });


    }


    Submit = () => {
        this.setState({SubmitAlert: ""});
        $("#SubmitAlert").removeClass('text-success');
        $("#SubmitAlert").removeClass('text-warning');


        var canvas = document.getElementById("sig-canvas");
        var dataUrl = canvas.toDataURL();

        let SignatureModel = {};
        SignatureModel.CollectionID = this.state.detail.CollectionID;
        SignatureModel.Signature = dataUrl;

        const url = this.props.apiprefix + 'pbreturnuploadsign?otp=' + this.state.detail.Otp;
        uisFetch(this.props.accessToken,url, {
            //mode: 'no-cors',
            method: "POST",
            headers: {
                "Content-type": "application/json; charset=utf-8"
            },
            body: JSON.stringify(SignatureModel)
        }).then((response) => {
            return response.json()
        }).then((result) => {
            if (this.props.debug) console.log("[Public] pbreturnuploadsign - result = " + result);

            console.log(result);

            // if(result == "Success")
            // $("#SubmitAlert").addClass('text-success');
            // else
            // $("#SubmitAlert").addClass('text-warning');

            //this.setState({ SubmitAlert: result });
            if (result.Signature == dataUrl) {
                $('#btnSuccess').click();

                setTimeout(
                    () => {
                        window.location.href = process.env.PUBLIC_URL || "/";
                    },
                    5000
                );
            }


        });


    }

    updateCanvas = () => {
        this.setState({CanvasUpdated: true});
    }

    CanvasClear = () => {
        this.setState({CanvasUpdated: false});
    }


    PassParmToModel(unifName, UniformId, imgIds) {
        this.setState({modelTitle: unifName});
        this.setState({modelUniformID: UniformId});
        this.setState({modelImgIds: imgIds});
    }

    test = () => {
        var canvas = document.getElementById("sig-canvas");
        var dataUrl = canvas.toDataURL();
        console.log(dataUrl);
        // sigText.innerHTML = dataUrl;
        // sigImage.setAttribute("src", dataUrl);   
    }


    renderCollectionDetail() {
        let ItemList;
        if (this.state.detail.ReturnItems == null) {
            ItemList = null;
        } else if (this.state.IsMobileView == false) {
            ItemList = this.state.detail.ReturnItems.map((m) => {
                let _accordionId, _headingId, _collapseId, _carouselIndId, row = 0;
                _accordionId = "mobDomRetItmAccordion" + row;
                _headingId = "mobDomRetItmHeading" + row;
                _collapseId = "mobDomRetItmCollapse" + row;
                _carouselIndId = "mobDomRetItmCarouselInd" + row;
                row++;
                return (
                    <tr key={m.UniformCode + "_" + m.SubCode}>
                        {/* <td >{m.UniformCode}_{m.SubCode}</td> */}
                        <td className="font-weight-bold align-middle">{m.UniformDescEN} <br/> {m.UniformDescHK}</td>
                        {/* <td> <a data-toggle="modal" data-target="#itemImgModal" className="btn btn-secondary center-block"
                            onClick={this.PassParmToModel.bind(this, m.UniformDescEN + " " + m.UniformDescHK, m.UniformID, m.ImgIds)}>
                            <div className="font-weight-bold text-white" >
                                <img src={`${process.env.PUBLIC_URL}/Images/glyphicons/glyphicons-139-picture-w.png`} />
                            </div>
                        </a></td> */}
                        <td className="align-middle">
                            {(() => {
                                console.log(m);
                                if (m.ImageList.length > 0) {
                                    return (<div id={_carouselIndId} className="carousel slide" data-ride="carousel"
                                                 data-interval="false">
                                            {/* <ol className="carousel-indicators">
                                                        {
                                                            m.ImgIds.map((imgId, index) => {
                                                                return <li key={_carouselIndId + "carouLi" + index} data-target={"#" + _carouselIndId} data-slide-to={index} className={"carousel-indicators-shape " + (index == 0 ? "active" : "")}></li>
                                                            })
                                                        }
                                                    </ol> */}
                                            <div className="carousel-inner" data-toggle="modal"
                                                 data-target="#itemImgModal"
                                                 onClick={this.PassParmToModel.bind(this, m.UniformDescEN + " " + m.UniformDescHK, m.UniformID, m.ImageList)}>
                                                {
                                                    m.ImageList.map((m2, index) => {
                                                        return <div key={_carouselIndId + "carouselItem" + index}
                                                                    className={"carousel-item " + (index == 0 ? "active" : "")}>
                                                            <div className="card-header" id={m2.imgId}>
                                                                <div className="col-12 text-center">
                                                                    {(() => {
                                                                    const key = `${m.UniformID}_${m2.ImgId}`;
                                                                    const blobUrl = this.state.measurementImages[key];
                                                                    if (!blobUrl) {
                                                                        this.loadMeasurementImage(m.UniformID, m2.ImgId);
                                                                        return <span>Loading...</span>;
                                                                    }
                                                                    if (m2.ImgFileName.toLowerCase().lastIndexOf(".pdf") <= 0) {
                                                                        return (
                                                                          <img src={blobUrl}
                                                                                className="d-block w-100 img-thumbnail "
                                                                            style={{ maxHeight: "100px", maxWidth: "100px", margin: "0 auto", }} />
                                                                        );
                                                                    } else {
                                                                        return (
                                                                            <a className="card-img-top image1 text-center" style={{ textAlign: 'center' }} alt="Card image cap" target="_blank"> {m2.ImgFileName} </a>
                                                                        );
                                                                    }
                                                                })()}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    })
                                                }
                                            </div>
                                            {m.ImageList.length > 1 &&
                                                <a className="carousel-control-prev" href={"#" + _carouselIndId}
                                                   role="button" data-slide="prev">
                                                    <span className="carousel-control-prev-icon bg-dark"
                                                          aria-hidden="true"></span>
                                                    <span className="sr-only">Previous</span>
                                                </a>
                                            }
                                            {m.ImageList.length > 1 &&
                                                <a className="carousel-control-next" href={"#" + _carouselIndId}
                                                   role="button" data-slide="next">
                                                    <span className="carousel-control-next-icon bg-dark"
                                                          aria-hidden="true"></span>
                                                    <span className="sr-only">Next</span>
                                                </a>
                                            }
                                        </div>
                                    )
                                } else {

                                    return (
                                        <div className="d-flex justify-content-center">
                                            <img name={m.Seq}
                                                 src={`${process.env.PUBLIC_URL}/Images/no-image.png`}
                                                 width='100%' className="img-thumbnail w-100"
                                                 style={{maxHeight: "100px", maxWidth: "100px"}}
                                                // onError={e => { if (e.target.src !== {`${process.env.PUBLIC_URL}/Images/no-image.png`}) { e.target.src = {`${process.env.PUBLIC_URL}/Images/no-image.png`} } }}
                                            />
                                        </div>
                                    )
                                }
                            })()}
                        </td>
                        <td className="font-weight-bold align-middle">{m.SubCodeDescEN} <br/> {m.SubCodeDescHK}</td>
                        {/* <td>{m.DistibutionLocation}</td> */}
                        <td className="font-weight-bold align-middle">{m.CollectedQty}</td>
                    </tr>
                );
            });
        } else {
            let _accordionId, _headingId, _collapseId, _carouselIndId, row = 0;
            ItemList = this.state.detail.ReturnItems.map((m) => {
                _accordionId = "mobDomRetItmAccordion" + row;
                _headingId = "mobDomRetItmHeading" + row;
                _collapseId = "mobDomRetItmCollapse" + row;
                _carouselIndId = "mobDomRetItmCarouselInd" + row;
                row++;
                return (
                    <div className="card shadow rounded mt-3" key={_accordionId + _headingId} id={_accordionId}>
                        {/* <img className="card-img-top" src={`${process.env.PUBLIC_URL}/Images/Penguins_300x225.jpg`} alt="Card image cap"></img> */}
                        <div className="card-header cardView-header-bg-Color" id={_headingId}>
                            <h5 className="mb-0 cardView-header-link" style={{textAlign: 'left'}}>
                                <a className="btn btn-link w-100" data-toggle="collapse" data-target={'#' + _collapseId}
                                   aria-expanded="true" aria-controls={_collapseId}>
                                    <label
                                        className="card-text h5 font-weight-bold">{m.UniformDescEN}<br/>{m.UniformDescHK}
                                    </label>
                                </a>
                            </h5>
                        </div>
                        <div id={_collapseId} className="collapse show" aria-labelledby={_headingId}
                             data-parent={'#' + _accordionId}>
                            <div className="card-body cardView-body-bg-Color text-sm-left ">
                                {/* <p className="text-center"><small className="card-text mb-2 text-muted col-12">{m.UniformCode}_{m.SubCode}</small></p>
                                <hr /> */}
                                <div className="row no-gutters">
                                    <div className={"col-12 col-md-4 my-auto d-flex justify-content-center"}>
                                        {(() => {
                                            if (m.ImageList.length > 0) {
                                                return (<div id={_carouselIndId} className="carousel slide"
                                                             data-ride="carousel" data-interval="false">
                                                        {/* <ol className="carousel-indicators">
                                                        {
                                                            m.ImgIds.map((imgId, index) => {
                                                                return <li key={_carouselIndId + "carouLi" + index} data-target={"#" + _carouselIndId} data-slide-to={index} className={"carousel-indicators-shape " + (index == 0 ? "active" : "")}></li>
                                                            })
                                                        }
                                                    </ol> */}
                                                        <div className="carousel-inner" data-toggle="modal"
                                                             data-target="#itemImgModal"
                                                             onClick={this.PassParmToModel.bind(this, m.UniformDescEN + " " + m.UniformDescHK, m.UniformID, m.ImageList)}>
                                                            {
                                                                m.ImageList.map((m2, index) => {
                                                                    return <div
                                                                        key={_carouselIndId + "carouselItem" + index}
                                                                        className={"carousel-item " + (index == 0 ? "active" : "")}>
                                                                        <div className="card-header" id={m2.imgId}>
                                                                            <div className="col-12 text-center">
                                                                                {(() => {
                                                                                    const key = `${m.UniformID}_${m2.ImgId}`;
                                                                                    const blobUrl = this.state.measurementImages[key];
                                                                                    if (!blobUrl) {
                                                                                        this.loadMeasurementImage(m.UniformID, m2.ImgId);
                                                                                        return <span>Loading...</span>;
                                                                                    }
                                                                                    if (m2.ImgFileName.toLowerCase().lastIndexOf(".pdf") <= 0) {
                                                                                        return (
                                                                                        <img src={blobUrl}
                                                                                                className="d-block w-100 img-thumbnail "
                                                                                            style={{ maxHeight: "100px", maxWidth: "100px", margin: "0 auto", }} />
                                                                                        );
                                                                                    } else {
                                                                                        return (
                                                                                            <a className="card-img-top image1 text-center" style={{ textAlign: 'center' }} alt="Card image cap" target="_blank"> {m2.ImgFileName} </a>
                                                                                        );
                                                                                    }
                                                                                })()}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                })
                                                            }
                                                        </div>
                                                        {m.ImageList.length > 1 &&
                                                            <a className="carousel-control-prev"
                                                               href={"#" + _carouselIndId} role="button"
                                                               data-slide="prev">
                                                                <span className="carousel-control-prev-icon bg-dark"
                                                                      aria-hidden="true"></span>
                                                                <span className="sr-only">Previous</span>
                                                            </a>
                                                        }
                                                        {m.ImageList.length > 1 &&
                                                            <a className="carousel-control-next"
                                                               href={"#" + _carouselIndId} role="button"
                                                               data-slide="next">
                                                                <span className="carousel-control-next-icon bg-dark"
                                                                      aria-hidden="true"></span>
                                                                <span className="sr-only">Next</span>
                                                            </a>
                                                        }
                                                    </div>
                                                )
                                            } else {

                                                return (<img name={m.Seq}
                                                             src={`${process.env.PUBLIC_URL}/Images/no-image.png`}
                                                             width='100%' className="img-thumbnail w-100"
                                                             style={{maxHeight: "225px", maxWidth: "225px"}}
                                                    // onError={e => { if (e.target.src !== {`${process.env.PUBLIC_URL}/Images/no-image.png`}) { e.target.src = {`${process.env.PUBLIC_URL}/Images/no-image.png`} } }}
                                                />)
                                            }
                                        })()}

                                    </div>
                                    <div className="col d-none d-md-block"
                                         style={{borderRight: "2px solid #a7a6a6"}}></div>
                                    <div className="col col-12 d-md-none d-lg-none mt-4"
                                         style={{borderBottom: "2px solid #a7a6a6"}}></div>
                                    <div
                                        className={"col-12 col-md-8 row " + (this.state.IsTabletView == false ? "mx-auto mt-3" : "my-auto")}>
                                        <div className="col-2 d-none d-md-block d-lg-none"/>
                                        <a className="btn btn-link cardView-header-link w-100 col-5 col-md-4 cardView-box-bg-color"><label
                                            className="mt-3"><span
                                            className={"font-weight-bold " + (this.state.IsTabletView == false ? "h5" : "h4")}>{m.SubCodeDescEN}
                                            <br/> {m.SubCodeDescHK}</span><br/><span className="text-muted">Size<br/>尺碼</span></label></a>
                                        <div className="col-1"/>
                                        <a className="btn btn-link cardView-header-link w-100 col-5 col-md-4 cardView-box-bg-color"><label
                                            className="mt-4"><span
                                            className={"font-weight-bold " + (this.state.IsTabletView == false ? "h5" : "h4")}>{m.CollectedQty}</span><br/><span
                                            className="text-muted">Qty<br/>已歸還數量</span></label></a>
                                        <div className="col-1 d-none d-md-block d-lg-none"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            });
        }

        let RemainOnHoldList;
        if (this.state.detail.RemainOnHoldItems == null) {
            RemainOnHoldList = null;
        } else if (this.state.IsMobileView == false) {
            RemainOnHoldList = this.state.detail.RemainOnHoldItems.map((m) => {
                let _accordionId, _headingId, _collapseId, _carouselIndId, row = 0;
                _accordionId = "mobDomNonRetItmAccordion" + row;
                _headingId = "mobDomNonRetItmHeading" + row;
                _collapseId = "mobDomNonRetItmCollapse" + row;
                _carouselIndId = "mobDomNonRetItmCarouselInd" + row;
                row++;
                return (
                    <tr key={m.UniformCode + "_" + m.SubCode}>
                        {/* <td>{m.UniformCode}_{m.SubCode}</td> */}
                        <td className="font-weight-bold align-middle">{m.UniformDescEN} <br/> {m.UniformDescHK}</td>
                        {/* <td> <a data-toggle="modal" data-target="#itemImgModal" className="btn btn-secondary center-block"
                            onClick={this.PassParmToModel.bind(this, m.UniformDescEN + " " + m.UniformDescHK, m.UniformID, m.ImgIds)}>
                            <div className="font-weight-bold text-white" >
                                <img src={`${process.env.PUBLIC_URL}/Images/glyphicons/glyphicons-139-picture-w.png`} />
                            </div>
                        </a></td> */}
                        <td className="align-middle">
                            {(() => {
                                if (m.ImageList.length > 0) {
                                    return (<div id={_carouselIndId} className="carousel slide" data-ride="carousel"
                                                 data-interval="false">
                                            {/* <ol className="carousel-indicators">
                                                        {
                                                            m.ImgIds.map((imgId, index) => {
                                                                return <li key={_carouselIndId + "carouLi" + index} data-target={"#" + _carouselIndId} data-slide-to={index} className={"carousel-indicators-shape " + (index == 0 ? "active" : "")}></li>
                                                            })
                                                        }
                                                    </ol> */}
                                            <div className="carousel-inner" data-toggle="modal"
                                                 data-target="#itemImgModal"
                                                 onClick={this.PassParmToModel.bind(this, m.UniformDescEN + " " + m.UniformDescHK, m.UniformID, m.ImageList)}>
                                                {
                                                    m.ImageList.map((m2, index) => {
                                                        return <div key={_carouselIndId + "carouselItem" + index}
                                                                    className={"carousel-item " + (index == 0 ? "active" : "")}>
                                                            <div className="card-header" id={m2.imgId}>
                                                                <div className="col-12 text-center">
                                                                    {(() => {
                                                                        const key = `${m.UniformID}_${m2.ImgId}`;
                                                                        const blobUrl = this.state.measurementImages[key];
                                                                        if (!blobUrl) {
                                                                            this.loadMeasurementImage(m.UniformID, m2.ImgId);
                                                                            return <span>Loading...</span>;
                                                                        }
                                                                        if (m2.ImgFileName.toLowerCase().lastIndexOf(".pdf") <= 0) {
                                                                            return (
                                                                            <img src={blobUrl}
                                                                                    className="d-block w-100 img-thumbnail "
                                                                                style={{ maxHeight: "100px", maxWidth: "100px", margin: "0 auto", }} />
                                                                            );
                                                                        } else {
                                                                            return (
                                                                                <a className="card-img-top image1 text-center" style={{ textAlign: 'center' }} alt="Card image cap" target="_blank"> {m2.ImgFileName} </a>
                                                                            );
                                                                        }
                                                                    })()}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    })
                                                }
                                            </div>
                                            {m.ImageList.length > 1 &&
                                                <a className="carousel-control-prev" href={"#" + _carouselIndId}
                                                   role="button" data-slide="prev">
                                                    <span className="carousel-control-prev-icon bg-dark"
                                                          aria-hidden="true"></span>
                                                    <span className="sr-only">Previous</span>
                                                </a>
                                            }
                                            {m.ImageList.length > 1 &&
                                                <a className="carousel-control-next" href={"#" + _carouselIndId}
                                                   role="button" data-slide="next">
                                                    <span className="carousel-control-next-icon bg-dark"
                                                          aria-hidden="true"></span>
                                                    <span className="sr-only">Next</span>
                                                </a>
                                            }
                                        </div>
                                    )
                                } else {

                                    return (
                                        <div className="d-flex justify-content-center">

                                            <img name={m.Seq}
                                                 src={`${process.env.PUBLIC_URL}/Images/no-image.png`}
                                                 width='100%' className="img-thumbnail w-100"
                                                 style={{maxHeight: "100", maxWidth: "100px"}}
                                                // onError={e => { if (e.target.src !== {`${process.env.PUBLIC_URL}/Images/no-image.png`}) { e.target.src = {`${process.env.PUBLIC_URL}/Images/no-image.png`} } }}
                                            />
                                        </div>
                                    )
                                }
                            })()}
                        </td>
                        <td className="font-weight-bold">{m.SubCodeDescEN} <br/> {m.SubCodeDescHK}</td>
                        <td className="font-weight-bold">{m.CollectedQty}</td>
                    </tr>
                )
            });
        } else {
            let _accordionId, _headingId, _collapseId, _carouselIndId, row = 0;
            RemainOnHoldList = this.state.detail.RemainOnHoldItems.map((m) => {
                _accordionId = "mobDomNonRetItmAccordion" + row;
                _headingId = "mobDomNonRetItmHeading" + row;
                _collapseId = "mobDomNonRetItmCollapse" + row;
                _carouselIndId = "mobDomNonRetItmCarouselInd" + row;
                row++;
                return (
                    <div className="card shadow rounded mt-3" key={_accordionId + _headingId} id={_accordionId}>
                        {/* <img className="card-img-top" src={`${process.env.PUBLIC_URL}/Images/Penguins_300x225.jpg`} alt="Card image cap"></img> */}
                        <div className="card-header cardView-header-bg-Color" id={_headingId}>
                            <h5 className="mb-0 cardView-header-link" style={{textAlign: 'left'}}>
                                <a className="btn btn-link w-100" data-toggle="collapse" data-target={'#' + _collapseId}
                                   aria-expanded="true" aria-controls={_collapseId}>
                                    <label
                                        className="card-text h5 font-weight-bold">{m.UniformDescEN}<br/>{m.UniformDescHK}
                                    </label>
                                </a>
                            </h5>
                        </div>
                        <div id={_collapseId} className="collapse show" aria-labelledby={_headingId}
                             data-parent={'#' + _accordionId}>
                            <div className="card-body cardView-body-bg-Color text-sm-left ">
                                {/* <p className="text-center"><small className="card-text mb-2 text-muted col-12">{m.UniformCode}_{m.SubCode}</small></p>
                                <hr /> */}
                                <div className="row no-gutters">
                                    <div className={"col-12 col-md-4 my-auto d-flex justify-content-center"}>
                                        {(() => {
                                            if (m.ImageList.length > 0) {
                                                return (<div id={_carouselIndId} className="carousel slide"
                                                             data-ride="carousel" data-interval="false">
                                                        {/* <ol className="carousel-indicators">
                                                        {
                                                            m.ImgIds.map((imgId, index) => {
                                                                return <li key={_carouselIndId + "carouLi" + index} data-target={"#" + _carouselIndId} data-slide-to={index} className={"carousel-indicators-shape " + (index == 0 ? "active" : "")}></li>
                                                            })
                                                        }
                                                    </ol> */}
                                                        <div className="carousel-inner" data-toggle="modal"
                                                             data-target="#itemImgModal"
                                                             onClick={this.PassParmToModel.bind(this, m.UniformDescEN + " " + m.UniformDescHK, m.UniformID, m.ImageList)}>
                                                            { m.ImageList.map((m2, index) => {
                                                                    return <div
                                                                        key={_carouselIndId + "carouselItem" + index}
                                                                        className={"carousel-item " + (index == 0 ? "active" : "")}>
                                                                        <div className="card-header" id={m2.imgId}>
                                                                            <div className="col-12 text-center">
                                                                                {(() => {
                                                                                    const key = `${m.UniformID}_${m2.ImgId}`;
                                                                                    const blobUrl = this.state.measurementImages[key];
                                                                                    if (!blobUrl) {
                                                                                        this.loadMeasurementImage(m.UniformID, m2.ImgId);
                                                                                        return <span>Loading...</span>;
                                                                                    }
                                                                                    if (m2.ImgFileName.toLowerCase().lastIndexOf(".pdf") <= 0) {
                                                                                        return (
                                                                                        <img src={blobUrl}
                                                                                                className="d-block w-100 img-thumbnail "
                                                                                            style={{ maxHeight: "100px", maxWidth: "100px", margin: "0 auto", }} />
                                                                                        );
                                                                                    } else {
                                                                                        return (
                                                                                            <a className="card-img-top image1 text-center" alt="Card image cap" target="_blank"> {m2.ImgFileName} </a>
                                                                                        );
                                                                                    }
                                                                                })()}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                })
                                                            }
                                                        </div>
                                                        {m.ImageList.length > 1 &&
                                                            <a className="carousel-control-prev"
                                                               href={"#" + _carouselIndId} role="button"
                                                               data-slide="prev">
                                                                <span className="carousel-control-prev-icon"
                                                                      aria-hidden="true"></span>
                                                                <span className="sr-only">Previous</span>
                                                            </a>
                                                        }
                                                        {m.ImageList.length > 1 &&
                                                            <a className="carousel-control-next"
                                                               href={"#" + _carouselIndId} role="button"
                                                               data-slide="next">
                                                                <span className="carousel-control-next-icon"
                                                                      aria-hidden="true"></span>
                                                                <span className="sr-only">Next</span>
                                                            </a>
                                                        }
                                                    </div>
                                                )
                                            } else {

                                                return (<img name={m.Seq}
                                                             src={`${process.env.PUBLIC_URL}/Images/no-image.png`}
                                                             width='100%' className="img-thumbnail w-100"
                                                             style={{maxHeight: "225px", maxWidth: "225px"}}
                                                    // onError={e => { if (e.target.src !== {`${process.env.PUBLIC_URL}/Images/no-image.png`}) { e.target.src = {`${process.env.PUBLIC_URL}/Images/no-image.png`} } }}
                                                />)
                                            }
                                        })()}

                                    </div>
                                    <div className="col d-none d-md-block"
                                         style={{borderRight: "2px solid #a7a6a6"}}></div>
                                    <div className="col col-12 d-md-none d-lg-none mt-4"
                                         style={{borderBottom: "2px solid #a7a6a6"}}></div>
                                    <div
                                        className={"col-12 col-md-8 row " + (this.state.IsTabletView == false ? "mx-auto mt-3" : "my-auto")}>
                                        <div className="col-2 d-none d-md-block d-lg-none"/>
                                        <a className="btn btn-link cardView-header-link w-100 col-5 col-md-4 cardView-box-bg-color"><label
                                            className="mt-3"><span
                                            className={"font-weight-bold " + (this.state.IsTabletView == false ? "h5" : "h4")}>{m.SubCodeDescEN}
                                            <br/> {m.SubCodeDescHK}</span><br/><span className="text-muted">Size<br/>尺碼</span></label></a>
                                        <div className="col-1"/>
                                        <a className="btn btn-link cardView-header-link w-100 col-5 col-md-4 cardView-box-bg-color"><label
                                            className="mt-4"><span
                                            className={"font-weight-bold " + (this.state.IsTabletView == false ? "h5" : "h4")}>{m.CollectedQty}</span><br/><span
                                            className="text-muted">Qty<br/>已歸還數量</span></label></a>
                                        <div className="col-1 d-none d-md-block d-lg-none"/>
                                    </div>
                                </div>
                                {/*
                                <div className="row">
                                    <div className="col-md hidden-xs" />
                                    <a className="btn btn-link cardView-header-link w-100 col-sm-5 col-xs-12 cardView-box-bg-color"><label className="mt-3"><span className="font-weight-bold h4">{m.SubCodeDescEN} <br /> {m.SubCodeDescHK}</span><br /><span className="text-muted">Size<br />尺碼</span></label></a>
                                    <div className="col" />
                                    <a className="btn btn-link cardView-header-link w-100 col-sm-4 col-xs-12 cardView-box-bg-color"><label className="mt-4"><span className="font-weight-bold h4">{m.CollectedQty}</span><br /><span className="text-muted">Qty<br />未歸還數量</span></label></a>
                                    <div className="col" />
                                </div> */}
                            </div>
                        </div>
                    </div>
                )
            });
        }

        return (

            <div className={"card-body " + (this.state.IsMobileView ? "card-body-wider" : "")}>


                <div className="form-row p-2">
                    <div className="col-sm-2"><label>Staff 姓名: </label></div>
                    <div
                        className="col-sm-10 font-weight-bold">{this.state.detail.StaffName} ({this.state.detail.ERN})
                    </div>
                </div>

                <div className="form-row p-2">
                    <div className="col-sm-2"><label>Position 職位: </label></div>
                    <div className="col-sm-10 font-weight-bold">{this.state.detail.Position}</div>
                </div>
                <hr/>


                <div id="collectionitem" className="form-group row">
                    {(() => {
                        if (this.state.IsMobileView == false) {
                            return (
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8">
                                    <div className="row col-sm-12">
                                        <label className="font-weight-bold text-success">Returned Item(s)
                                            已歸還的制服: </label>
                                        <span className="badge badge-pill badge-success ml-2 my-auto"
                                              hidden={this.state.detail.ReturnItems == null || this.state.detail.ReturnItems.length == 0 ? true : false}>{this.state.detail.ReturnItems != null ? this.state.detail.ReturnItems.length : 0}</span>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="tableFixHead table-responsive">
                                            <table className="table table-striped dt-responsive w-100">
                                                <tbody>
                                                {ItemList}
                                                </tbody>
                                                <thead>
                                                <tr>
                                                    {/* <th scope="col-sm">Uniform Sub-Code<br />制服編碼</th>
                                                        <th scope="col-sm">Description<br />項目</th> */}
                                                    <th scope="col">Uniform<br/>制服</th>
                                                    <th scope="col">Image<br/>制服圖片</th>
                                                    <th scope="col">Size<br/>尺碼</th>
                                                    {/* <th scope="col-sm">Distribution Location<br />派發地點</th> */}
                                                    <th scope="col">Qty<br/>已歸還數量</th>
                                                </tr>
                                                </thead>

                                            </table>
                                        </div>
                                    </div>

                                    <div className="row col-sm-12">
                                        <label className="font-weight-bold text-danger"
                                               hidden={this.state.detail.RemainOnHoldItems == null || this.state.detail.RemainOnHoldItems.length <= 0 ? true : false}>Non
                                            Return Item(s) 未歸還的制服: </label>
                                        <span className="badge badge-pill badge-danger ml-2 my-auto"
                                              hidden={this.state.detail.RemainOnHoldItems == null || this.state.detail.RemainOnHoldItems.length == 0 ? true : false}>{this.state.detail.RemainOnHoldItems != null ? this.state.detail.RemainOnHoldItems.length : 0}</span>
                                    </div>
                                    <div className="col-sm-12">
                                        <div
                                            hidden={this.state.detail.RemainOnHoldItems == null || this.state.detail.RemainOnHoldItems.length <= 0 ? true : false}
                                            className="tableFixHead table-responsive">
                                            <table className="table table-striped dt-responsive w-100">
                                                <tbody>
                                                {RemainOnHoldList}
                                                </tbody>
                                                <thead>
                                                <tr>
                                                    {/* <th scope="col-sm">Uniform Sub-Code<br />制服編碼</th>
                                                        <th scope="col-sm">Description<br />項目</th> */}
                                                    <th scope="col">Uniform<br/>制服</th>
                                                    <th scope="col">Image<br/>制服圖片</th>
                                                    <th scope="col">Size<br/>尺碼</th>
                                                    <th scope="col">Qty<br/>未歸還數量</th>
                                                </tr>
                                                </thead>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            )
                        } else {
                            return (
                                <div className="col-12">
                                    <ul className="nav nav-tabs tab-fix-top" style={{fontSize: "medium", top: "68px"}}
                                        role="tablist">
                                        <li className="nav-item"><label
                                            className={"tabLink-color active " + (this.state.IsSmMobileView ? "small" : "")}
                                            data-toggle="tab" role="tab" aria-controls="returnedItm"
                                            href="#returnedItm">Returned Item(s) <br
                                            className="d-block d-sm-none"/>已歸還的制服 <span
                                            className="badge badge-pill badge-success">{this.state.detail.ReturnItems != null ? this.state.detail.ReturnItems.length : 0}</span></label>
                                        </li>
                                        <li className="nav-item"><label
                                            className={"tabLink-color " + (this.state.IsSmMobileView ? "small" : "")}
                                            data-toggle="tab" role="tab" aria-controls="nonReturnItm"
                                            href="#nonReturnItm">Non Return Item(s) <br
                                            className="d-block d-sm-none"/> 未歸還的制服 <span
                                            className="badge badge-pill badge-danger">{this.state.detail.RemainOnHoldItems != null ? this.state.detail.RemainOnHoldItems.length : 0}</span></label>
                                        </li>
                                    </ul>

                                    <div className="tab-content">
                                        <div id="returnedItm" className="tab-pane fade show active">
                                            <div className="mt-2">
                                                {ItemList}
                                            </div>
                                        </div>
                                        <div id="nonReturnItm" className="tab-pane fade">
                                            {(() => {
                                                if (this.state.detail.RemainOnHoldItems != null && this.state.detail.RemainOnHoldItems.length > 0) {
                                                    return (<div className="mt-2">
                                                            {RemainOnHoldList}
                                                        </div>
                                                    )
                                                } else {
                                                    return (
                                                        <div className="text-center h5"
                                                             style={{padding: "150px 0px 150px 0px"}}>
                                                            <label>No non Return Item(s)<br/>沒有未歸還的制服</label>
                                                        </div>
                                                    )
                                                }
                                            })()}
                                        </div>
                                    </div>
                                </div>)
                        }
                    })()}

                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4">
                        <div className="">
                            <label className="col-form-label text-info font-weight-bold mt-4 mt-lg-0">Signature
                                簽署確認: </label>
                            <div className="col-sm-12">
                                {/* <canvas id="can" style={divStyle} className="w-200" width='500px' height='300px'></canvas> */}
                                <canvas id="sig-canvas" style={{border: '2px solid', cursor: 'crosshair'}}
                                        // width={this.state.IsTabletView === false ? (this.state.IsSmMobileView === false ? "300" : "250") : "500"}
                                        // height={this.state.IsTabletView === false ? "200" : "300"}
                                        width={"500"}
                                        height={"300"}
                                        onMouseDown={this.updateCanvas.bind(this)}
                                        onTouchStart={this.updateCanvas.bind(this)}/>
                            </div>
                            <div className="col-sm-12">
                                {/* <button type="button" className="btn btn-secondary" onClick={this.erase}>Clear</button> */}
                                {/* <button type="button" className="btn btn-primary" onClick={this.test.bind(this)} >test</button> */}
                                {/* <button type="button" className="btn btn-secondary" id="sig-clearBtn">Clear</button> */}
                            </div>
                        </div>
                    </div>
                    {/* <div className="row">
			<div className="col-md-12">
				<h1>E-Signature</h1>
				<p>Sign in the canvas below and save your signature as an image!</p>
			</div>
		</div>
		<div className="row">
			<div className="col-md-12">
		 		<canvas id="sig-canvas" style={divStyle} className="w-200" width='500px' height='300px' >
		 			Get a better browser, bro.
		 		</canvas>
		 	</div>
		</div>
		<div className="row">
			<div className="col-md-12">
				<button className="btn btn-primary" id="sig-submitBtn">Submit Signature</button>
				<button className="btn btn-default" id="sig-clearBtn">Clear Signature</button>
			</div>
		</div>
		<br/>
		<div className="row">
			<div className="col-md-12">
				<textarea id="sig-dataUrl" className="form-control" rows="5">Data URL for your signature will go here!</textarea>
			</div>
		</div>
		<br/>
		<div className="row">
			<div className="col-md-12">
				<img id="sig-image" src="" alt="Your signature will go here!"/>
			</div>
		</div> */}
                </div>
                <br/>
                <div className="form-row d-flex">
                    <div className="mx-auto">
                        <div className={"row "}>
                            <a className="btn btn-primary text-white" hidden={!this.state.CanvasUpdated}
                               onClick={this.Submit.bind(this)}>Submit 提交</a>
                            <span>&nbsp;</span>
                            <button type="button" className="btn btn-secondary" id="sig-clearBtn"
                                    onClick={this.CanvasClear.bind(this)}>Clear 清除
                            </button>
                            <span>&nbsp;</span>
                            <div id="SubmitAlert" className="font-weight-bold">{this.state.SubmitAlert}</div>
                            <span>&nbsp;</span>
                            <a id="btnSuccess" className="btn btn-info" hidden data-toggle="collapse"
                               href="#collapseThree" role="button" aria-expanded="false"
                               aria-controls="collapseThree">HIDDEN</a>

                            {/*<span>&#xA0;</span>
                            <button className="btn btn-secondary" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">Start Over</button> */}
                        </div>
                    </div>
                </div>

            </div>
        );
    }


    renderItemImgModal() {

        return (

            <div className="modal fade" id='itemImgModal' role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{this.state.modelTitle}</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body modal-body-autoHeight">
                            {(() => {
                                if (this.state.modelImgIds.length > 0) {
                                    return (
                                        <div id="_carouselIndId" className="carousel slide" data-ride="carousel"
                                             data-interval="false">
                                            {/* <ol className="carousel-indicators">
                                                {
                                                    this.state.modelImgIds.map((imgId, index) => {
                                                        return <li key={"modelLi" + index + Math.floor(Math.random() * 1000) + Math.floor(Math.random() * 1000)} data-target="#_carouselIndId" data-slide-to={index} className={"carousel-indicators-shape " + (index == 0 ? "active" : "")}></li>
                                                    })
                                                }
                                            </ol> */}
                                            <div className="carousel-inner">
                                                {
                                                    this.state.modelImgIds.map((m, index) => {

                                                        const key = `${this.state.modelUniformID }_${m.ImgId}`;
                                                        const blobUrl = this.state.uniformdownloadattachement[key];
                                                        if (!blobUrl) {
                                                            this.loadUniformdownloadattachement(this.state.modelUniformID , m.ImgId);
                                                        }
                                                        return <div
                                                            key={"modelImg" + index + Math.floor(Math.random() * 1000) + Math.floor(Math.random() * 1000)}
                                                            className={"carousel-item " + (index == 0 ? "active" : "")}>
                                                            <div className="card">
                                                                <div className="col-12" style={{
                                                                    display: 'flex',
                                                                    justifyContent: 'center',
                                                                    alignItems: 'center',
                                                                    height: '100vh'
                                                                }}>
                                                                    {m.ImgFileName.toLowerCase().lastIndexOf(".pdf") <= 0 ? (
                                                                        blobUrl ? (
                                                                            <a target="_blank" href={blobUrl} rel="noopener noreferrer" download={m.ImgFileName}>
                                                                                <img className="img-thumbnail text-center" src={blobUrl} alt="Card image cap"/>
                                                                            </a>
                                                                        ) : (
                                                                            <div>Loading image...</div>
                                                                        )
                                                                    ) : (
                                                                        blobUrl ? (
                                                                            <a className="card-img-top image1 text-center" href={blobUrl} alt="Card image cap" download={m.ImgFileName}
                                                                            target="_blank" rel="noopener noreferrer">Click to preview {m.ImgFileName} </a>
                                                                        ) : (
                                                                            <div>Loading PDF...</div>
                                                                        )
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    })
                                                }
                                            </div>
                                            {this.state.modelImgIds.length > 1 &&
                                                <a className="carousel-control-prev" href="#_carouselIndId"
                                                   role="button" data-slide="prev">
                                                    <span className="carousel-control-prev-icon carousel-control-shape"
                                                          aria-hidden="true"></span>
                                                    <span className="sr-only">Previous</span>
                                                </a>
                                            }
                                            {this.state.modelImgIds.length > 1 &&
                                                <a className="carousel-control-next" href="#_carouselIndId"
                                                   role="button" data-slide="next">
                                                    <span className="carousel-control-next-icon carousel-control-shape"
                                                          aria-hidden="true"></span>
                                                    <span className="sr-only">Next</span>
                                                </a>
                                            }
                                        </div>
                                    )
                                } else {
                                    return (
                                        <img src={`${process.env.PUBLIC_URL}/Images/no-image.png`} width='100%' className="img-thumbnail w-100"/>)
                                }
                            })()}
                            {/* <img src={this.state.modelImgUrl}
                                    width='95%' className="img-thumbnail" onError={e => { if (e.target.src !== {`${process.env.PUBLIC_URL}/Images/no-image.png`}) { e.target.src = {`${process.env.PUBLIC_URL}/Images/no-image.png`} } }} /> */}
                        </div>
                    </div>
                </div>
            </div>
        )
    }


    async loadMeasurementImage(uniformId, imgId) {
        const key = `${uniformId}_${imgId}`;
        const now = Date.now();
        
        // If already have data, return directly
        if (this.state.measurementImages[key]) {
            return;
        }
        
        // If currently loading, return directly
        if (this.state.loadingImages[key]) {
            return;
        }
        
        // Check if within cooldown period
        const lastLoadTime = this.state.imageLoadTimestamps[key];
        if (lastLoadTime && (now - lastLoadTime) < this.REQUEST_COOLDOWN) {
            return;
        }
        
        // Set loading state and timestamp
        this.setState(prevState => ({
            loadingImages: {
                ...prevState.loadingImages,
                [key]: true
            },
            imageLoadTimestamps: {
                ...prevState.imageLoadTimestamps,
                [key]: now
            }
        }));
        
        try {
            const url = `${this.props.apiprefix}getimage?unm=${uniformId}&uni=${imgId}`;
            const base64Data = await fetchAndConvertToBase64(url, this.props.accessToken);
            
            if (base64Data) {
                this.setState((prevState) => ({
                    measurementImages: {
                        ...prevState.measurementImages,
                        [key]: base64Data,
                    },
                    loadingImages: {
                        ...prevState.loadingImages,
                        [key]: false
                    }
                }));
            } else {
                this.setState(prevState => ({
                    loadingImages: {
                        ...prevState.loadingImages,
                        [key]: false
                    }
                }));
            }
        } catch (error) {
            console.error(`load measurement image error ${key}:`, error);
            this.setState(prevState => ({
                loadingImages: {
                    ...prevState.loadingImages,
                    [key]: false
                }
            }));
        }
    }
    
    async loadUniformdownloadattachement(modelUniformID, documentId) {
        const key = `${modelUniformID}_${documentId}`;
        const now = Date.now();
        
        // If already have data, return directly
        if (this.state.uniformdownloadattachement[key]) {
            return;
        }
        
        // If currently loading, return directly
        if (this.state.loadingImages[key]) {
            return;
        }
        
        // Check if within cooldown period
        const lastLoadTime = this.state.imageLoadTimestamps[key];
        if (lastLoadTime && (now - lastLoadTime) < this.REQUEST_COOLDOWN) {
            return;
        }
        
        // Set loading state and timestamp
        this.setState(prevState => ({
            loadingImages: {
                ...prevState.loadingImages,
                [key]: true
            },
            imageLoadTimestamps: {
                ...prevState.imageLoadTimestamps,
                [key]: now
            }
        }));
        
        try {
            const url = this.props.apiprefix + 'uniformdownloadattachement?unm=' + modelUniformID+ '&uni=' +  documentId;
            const base64Data = await fetchAndConvertToBase64(url, this.props.accessToken);
            
            if (base64Data) {
                this.setState((prevState) => ({
                    uniformdownloadattachement: {
                        ...prevState.uniformdownloadattachement,
                        [key]: base64Data,
                    },
                    loadingImages: {
                        ...prevState.loadingImages,
                        [key]: false
                    }
                }));
            } else {
                this.setState(prevState => ({
                    loadingImages: {
                        ...prevState.loadingImages,
                        [key]: false
                    }
                }));
            }
        } catch (error) {
            console.error(`load uniform attachment error ${key}:`, error);
            this.setState(prevState => ({
                loadingImages: {
                    ...prevState.loadingImages,
                    [key]: false
                }
            }));
        }
    }

    render() {


        return (


            <div className="container bg-secondary " style={{minHeight: '100vh', minWidth: 'fit-content'}}>

                <div className={"col-12 " + (this.state.IsMobileView ? "card-body-wider" : "")}>
                    <br hidden={this.state.IsMobileView ? true : false}/>
                    <div id="application-card" className="card border-light bg-light" style={{"minHeight": '95vh'}}>
                        <div id="application-card-header" className={"card-header text-white tab-fix-top"}>
                            <div className="d-flex">
                                <div className="mr-auto"><label
                                    className={this.state.IsMobileView ? (this.state.IsTabletView == false ? "h6" : "h5") : "h3"}>UIS
                                    - Return Form 制服歸還表</label></div>
                                <div>
                                    <a id="btnHome" className="btn btn-secondary center-block" href={`${process.env.PUBLIC_URL}/home`}
                                       role="button"><img src={`${process.env.PUBLIC_URL}/Images/glyphicons/glyphicons-21-home.png`} width='30px'/></a>

                                </div>
                            </div>
                        </div>
                        <div className={"card-body " + (this.state.IsMobileView ? "card-body-wider" : "")}>
                            <br hidden={this.state.IsMobileView ? true : false}/>
                            <form>
                                <div className="form-group">
                                    <div>
                                        <div className="accordion" id="accordionExample">
                                            <div className="card">

                                                <div id="collapseOne" className="collapse show"
                                                     aria-labelledby="headingOne" data-parent="#accordionExample">
                                                    <div className="card-body">


                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>

                                                        <div className="d-flex">
                                                            <div className="mx-auto">
                                                                <div className="form-row">
                                                                    <h2 className="w-100 text-center">Please Type in PIN
                                                                        for Your Uniform Return<br/>請將認證碼輸入在以下空格
                                                                    </h2>
                                                                </div>
                                                                <div className="gap-line col-12"/>
                                                                <div className="gap-line col-12"/>
                                                                <div className="gap-line col-12"/>
                                                                <div className="gap-line col-12"/>
                                                                <div className="gap-line col-12"/>
                                                                <div className="gap-line col-12"/>
                                                                <div className="gap-line col-12"/>
                                                                <div className="gap-line col-12"/>
                                                                <div className="gap-line col-12"/>
                                                                <div className="form-row">
                                                                    <label className="col-form-label">PIN
                                                                        認證碼: </label>
                                                                    <input id="inpOTP" type="number" pattern="[0-9]*"
                                                                           inputMode="numeric" className="form-control"
                                                                           value={this.state.OTP}
                                                                           onKeyPress={(e) => this.Go(e)}
                                                                           onChange={(e) => this.UpdateOTP(e)} style={{
                                                                        "maxWidth": '100%',
                                                                        "whiteSpace": 'pre-line',
                                                                        "position": 'relative'
                                                                    }}/>
                                                                </div>


                                                                <div className="gap-line col-12"/>
                                                                <div className="gap-line col-12"/>
                                                                <div className="gap-line col-12"/>
                                                                <div className="gap-line col-12"/>
                                                                <div className="gap-line col-12"/>
                                                                <div className="gap-line col-12"/>
                                                                <div className="form-row">
                                                                    <a id="btnContinue"
                                                                       className="btn btn-info text-white"
                                                                       onClick={this.Proceed.bind(this)}>Continue
                                                                        下一步</a>
                                                                    <span>&nbsp;</span>
                                                                    <div
                                                                        className="font-weight-bold text-danger">{this.state.OTPInputAlert}</div>
                                                                    <a id="btnProceed" className="btn btn-info" hidden
                                                                       data-toggle="collapse" href="#collapseTwo"
                                                                       role="button" aria-expanded="false"
                                                                       aria-controls="collapseTwo">HIDDEN</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>


                                                    </div>


                                                </div>
                                            </div>
                                            <div className="card"
                                                 style={this.state.IsMobileView ? {overflow: "initial"} : {}}>
                                                <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo"
                                                     data-parent="#accordionExample">
                                                    <div className="card-header text-secondary">
                                                        <label className={this.state.IsMobileView ? "h6" : "h3"}>Your
                                                            Uniform Return Details 歸還制服詳情</label>
                                                    </div>
                                                    {this.renderItemImgModal()}
                                                    {this.renderCollectionDetail()}
                                                    <a id="btnBottom" href="#sig-canvas"
                                                       style={this.state.IsMobileView ? {} : {display: 'none'}}>V</a>
                                                </div>
                                            </div>
                                            <div className="card">
                                                <div id="collapseThree" className="collapse"
                                                     aria-labelledby="headingThree" data-parent="#accordionExample">
                                                    <div className="card-body">
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>

                                                        <div className="d-flex">
                                                            <div className="mx-auto">
                                                                <div className="text-success"><h2>Success 完成</h2>
                                                                </div>
                                                                <div>系統將於5秒後返回首頁</div>
                                                            </div>
                                                        </div>


                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                        <div className="gap-line col-12"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CustomerReturn;



